var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wxButton"},[_c('van-button',{on:{"click":_vm.chooseWxInvoice}},[_vm._v("选择微信发票")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }